module.exports = __webpack_public_path__ + "img/logo-reuniontributaria.db008e8a.png";